import * as SecureAccess from './SecureAccess.css';
export default {
    SecureAccess
};
